"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = require("axios");
const api_1 = require("@/api");
const errors_1 = require("@/common/errors");
const functions_1 = require("@/common/functions");
function default_1() {
    var _a, _b, _c, _d;
    return __awaiter(this, void 0, void 0, function* () {
        const orderId = (0, functions_1.getNumberFromUrl)(window.location.pathname);
        try {
            const response = yield (0, api_1.getData)(`/api/v1/order/${orderId}/payment`);
            if (response.status === 200) {
                const { result } = response.data;
                const { order_status_cd_id, total_product_price, total_delivery_price, total_donation_price, } = result;
                const isPurchased = order_status_cd_id !== 'ORDER_STATUS_01';
                const totalPrice = total_product_price + total_delivery_price + total_donation_price;
                return Object.assign(Object.assign({}, result), { totalPrice, user_agreements: isPurchased });
            }
        }
        catch (error) {
            if (error instanceof axios_1.AxiosError) {
                const errorStatus = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status;
                const errorCode = (_d = (_c = (_b = error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.meta) === null || _d === void 0 ? void 0 : _d.alert_type;
                switch (errorStatus) {
                    case 400:
                        return { order_status_cd_id: 'invisibleOrder' };
                    case 403:
                        (0, errors_1.handle403Error)(error);
                        break;
                    case 404:
                        return { order_status_cd_id: 'formNotFound' };
                    default:
                        alert((0, errors_1.commonErrorMsg)(errorCode || errorStatus));
                }
            }
            else {
                alert((0, errors_1.commonErrorMsg)());
            }
            return { order_status_cd_id: 'invalidAccess' };
        }
    });
}
exports.default = default_1;
